/* tslint:disable */
/* eslint-disable */
/* @relayHash afac9ba5ec13cf275f93e448ad2485ea */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MainRouteQueryVariables = {};
export type MainRouteQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"ErrorReporterSetUserContainer_viewer" | "UserMenuContainer_viewer" | "NavigationContainer_viewer">;
    } | null;
    readonly settings: {
        readonly " $fragmentRefs": FragmentRefs<"NavigationContainer_settings">;
    };
};
export type MainRouteQuery = {
    readonly response: MainRouteQueryResponse;
    readonly variables: MainRouteQueryVariables;
};



/*
query MainRouteQuery {
  viewer {
    ...ErrorReporterSetUserContainer_viewer
    ...UserMenuContainer_viewer
    ...NavigationContainer_viewer
    id
  }
  settings {
    ...NavigationContainer_settings
    id
  }
}

fragment ErrorReporterSetUserContainer_viewer on User {
  id
  username
  role
}

fragment NavigationContainer_settings on Settings {
  multisite
}

fragment NavigationContainer_viewer on User {
  role
  moderationScopes {
    sites {
      id
    }
  }
}

fragment UserMenuContainer_viewer on User {
  username
}
*/

const node: ConcreteRequest = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "MainRouteQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "ErrorReporterSetUserContainer_viewer"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "UserMenuContainer_viewer"
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "NavigationContainer_viewer"
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "NavigationContainer_settings"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "MainRouteQuery",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "viewer",
                    "plural": false,
                    "selections": [
                        (v0 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "username",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "role",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "UserModerationScopes",
                            "kind": "LinkedField",
                            "name": "moderationScopes",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Site",
                                    "kind": "LinkedField",
                                    "name": "sites",
                                    "plural": true,
                                    "selections": [
                                        (v0 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Settings",
                    "kind": "LinkedField",
                    "name": "settings",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "multisite",
                            "storageKey": null
                        },
                        (v0 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "afac9ba5ec13cf275f93e448ad2485ea",
            "metadata": {},
            "name": "MainRouteQuery",
            "operationKind": "query",
            "text": null
        }
    } as any;
})();
(node as any).hash = 'a1099e07a06cf0b0ab5ffed7b7d3728d';
export default node;
